<template>
    <div class="container flip-clock">
        <template v-for="data in timeData" v-show="show">
            <span v-bind:key="data.label" class="flip-clock__piece" :id="data.elementId">
                <span class="flip-clock__card flip-card">
                <b class="flip-card__top">{{data.current | twoDigits}}</b>
                <b class="flip-card__bottom" v-bind:data-value="data.current | twoDigits"></b>
                <b class="flip-card__back" v-bind:data-value="data.previous | twoDigits"></b>
                <b class="flip-card__back-bottom" v-bind:data-value="data.previous | twoDigits"></b>
                </span>
                <span class="flip-clock__slot">{{data.label}}</span>
            </span>
        </template>
    </div>
</template>

<script>
let interval = null
// const uuidv4 = require('uuid/v4')

export default {
  name: 'flip-countdown-ba',
  props: ["props", "translation"],
  data () {
    return {
      now: this.props.data_created,
      now2: this.props.data_created,
      date: null,
      dat2: null,
      interval: null,
      diff: 0,
      show: false,
      timeData: [
        {
          current: 0,
          previous: 0,
          label: this.translation.days,
          elementId: 'flip-card-days'
        },
        {
          current: 0,
          previous: 0,
          label: this.translation.hours,
          elementId: 'flip-card-hours'
        },
        {
          current: 0,
          previous: 0,
          label: this.translation.minutes,
          elementId: 'flip-card-minutes'
        },
        {
          current: 0,
          previous: 0,
          label: this.translation.seconds,
          elementId: 'flip-card-seconds'
        }
      ]
    }
  },
  created () {
    this.date = this.props.data_limite;
    this.now = this.props.data_atual;
    
    this.diff = this.date - this.now;
    // console.log(this.props, this.diff);
    
    this.interval = setInterval(() => {
    this.now = new Date(this.now);
    this.now.setSeconds(this.now.getSeconds() + 1);
    }, 1050)
  },
  mounted () {
    if (this.diff !== 0) {
      this.show = true
    }
  },
  computed: {
    seconds () {
      return Math.floor((this.diff % (1000 * 60)) / 1000);
    },
    minutes () {
      return Math.floor((this.diff % (1000 * 60 * 60)) / (1000 * 60));
      
    },
    hours () {
      return Math.floor((this.diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    },
    days () {
      return Math.floor(this.diff / (1000 * 60 * 60 * 24));
    }
  },
  watch: {
    now (value) {
      this.diff = this.date - this.now;
      if (this.diff <= 0) {
        this.diff = 0
        this.updateTime(3, 0)
        clearInterval(this.interval)
      } else {
        this.updateTime(0, this.days)
        this.updateTime(1, this.hours)
        this.updateTime(2, this.minutes)
        this.updateTime(3, this.seconds)
      }
    }
  },
  filters: {
    twoDigits (value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  },
  methods: {
    updateTime (idx, newValue) {
      if (idx >= this.timeData.length || newValue === undefined) {
        return
      }

      if (window['requestAnimationFrame']) {
        this.frame = requestAnimationFrame(this.updateTime.bind(this))
      }

      const d = this.timeData[idx]
      const val = (newValue < 0 ? 0 : newValue)

      if (val !== d.current) {
        d.previous = d.current
        d.current = val

        const el = document.querySelector(`#${d.elementId}`)
        // if (el) {
        //   el.classList.remove('flip')
        //   void el.offsetWidth
        //   el.classList.add('flip')
        // }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;
    &.container {
    width: unset !important;
  }

}


.flip-clock__piece {
  display: inline-flex;
  flex-direction: column-reverse;
  justify-content: center;
  margin: 0 0.2vw;
      &:nth-child(4) {
      .flip-clock__card.flip-card {
        &::after {
          content: "" !important;
        }
      }
    }
    .flip-clock__card.flip-card {
      margin-right: 1.4rem;
      &::before {
        content: "";
        width: 6px;
        height: 68px;
        background: white;
        position: absolute;
        right: 36px;
        top: -1px;
        z-index: 999;
      }
      &::after {
        content: ":";
        position: absolute;
        right: -21px;
        top: 10px;
      }
    }
  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}

.flip-clock__slot {
  margin-right: 1.2rem;
  font-size: .9rem;
  margin-bottom: .7rem;
}

$halfHeight: 0.72em;
$borderRadius: 0.15em;

.flip-card {
  display: block;
  position: relative;
  padding-bottom: $halfHeight;
  font-size: 2.25rem;
  line-height: 0.95;
}

@media (min-width: 1000px) {
  .flip-card { font-size: 3rem; }
}

.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: $halfHeight;
  color: white;
  background: #222;
  padding: 0.23em 0.15em 0.4em;
  border-radius: $borderRadius $borderRadius 0 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
  font-size: 2.9rem;
  letter-spacing: 13px;
  width: 5rem;
  height: $halfHeight;
}

.flip-card__bottom,
.flip-card__back-bottom {
  color: white;
  position: absolute;
  top: 49%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 $borderRadius $borderRadius;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}

.flip-card__back-bottom {
  z-index: 1;
}

.flip-card__bottom::after,
.flip-card__back-bottom::after {
  display: block;
  margin-top: -$halfHeight;
}

.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after {
  content: attr(data-value);
}

.flip-card__back {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}

.flip-card__back::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.flip .flip-card__back::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(.37,.01,.94,.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}

.flip .flip-card__bottom {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(.15,.45,.28,1);
}

@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%, 99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}

@keyframes flipBottom {
  0%, 50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/countdownClock.vue